import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: localStorage.hasOwnProperty('athlete') && localStorage.getItem('athlete') && localStorage.getItem('athlete') !== 'undefined'
  },
  mutations: {
    setIsLoggedIn (state, data) {
      state.isLoggedIn = data
    }

  },
  actions: {

  }
})
